import { api } from '../../api/fetch';

export const fetchUserAssets = async () => {
    console.info('fetch user assets');
  return await api.get('/api/v1/assets');
};

export default fetchUserAssets;
